
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Jurimama P.',
      procedure: 'Reabilitação Oral Completa',
      quote: 'Sou paciente do Dr. Luiz há alguns anos e considero o trabalho dele excelente. Ele refez todo o procedimento que outro profissional havia feito incorretamente, sempre com muito cuidado e precisão. Fez toda a diferença na minha vida. Hoje viajo 210 km apenas para ser atendida por ele. Recomendo de olhos fechados!'
    },
    {
      name: 'Vilma R.',
      procedure: 'Prótese Dentária',
      quote: 'Estava muito insatisfeita com minha prótese anterior. Após o tratamento com o Dr. Luiz, só tenho a agradecer. Estou muito satisfeita com o resultado. Ele é um excelente profissional, sempre atencioso e cuida muito bem dos seus pacientes. Recomendo com certeza!'
    },
    {
      name: 'Altamira S.',
      procedure: 'Prótese Dentária',
      quote: 'Para mim, o Dr. Luiz é um excelente profissional. Não tenho como agradecer por ser sempre bem atendida. Ele é sempre atencioso e trata muito bem seus pacientes. Parabéns pelo trabalho!'
    },
    {
      name: 'Visani L.',
      procedure: 'Estética Dental',
      quote: 'Eu estava muito incomodada com a estética do meu sorriso. Após o tratamento, me senti outra pessoa! Indico de olhos fechados. O atendimento é acolhedor e me senti muito à vontade durante todo o processo.'
    },
    {
      name: 'Almir Z.',
      procedure: 'Tratamento Periodontal',
      quote: 'Estava com uma infecção bacteriana muito resistente. Com o tratamento do Dr. Luiz, estou bem melhor e seguindo o protocolo corretamente. Um profissional sério e comprometido.'
    },
    {
      name: 'Divino X.',
      procedure: 'Atendimento Geral',
      quote: 'Fui muito bem atendido. O Dr. Luiz fez um trabalho excelente. Recomendo para quem precisar de um profissional de confiança.'
    }
  ];

  return (
    <section className="py-20 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#5A5A5A] mb-4">
            Pacientes do <strong className="text-[#6B2432]">Dr. Luiz Renato Kreb</strong>
          </h2>
          <p className="text-lg text-[#5A5A5A] max-w-3xl mx-auto">
            Depoimentos reais de pacientes que confiaram no Dr. Luiz Renato Kreb 
            para transformar seus sorrisos e melhorar sua qualidade de vida.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 relative"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 -left-4 w-8 h-8 bg-[#6B2432] rounded-full flex items-center justify-center">
                <i className="ri-double-quotes-l text-white text-lg"></i>
              </div>

              {/* Patient Info */}
              <div className="text-center mb-6">
                <h3 className="text-lg font-semibold text-[#5A5A5A]">
                  {testimonial.name}
                </h3>
                <p className="text-sm text-[#6B2432] font-medium">
                  {testimonial.procedure}
                </p>
              </div>

              {/* Quote */}
              <blockquote className="text-[#5A5A5A] leading-relaxed mb-6 italic">
                "{testimonial.quote}"
              </blockquote>

              {/* Stars */}
              <div className="flex justify-center space-x-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#6B2432] text-lg"></i>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <p className="text-lg text-[#5A5A5A] mb-6">
            Quer ser o próximo a transformar seu sorriso?
          </p>
          <a
            href="https://wa.me/5544999297166"
            className="inline-flex items-center bg-[#6B2432] text-white px-8 py-4 rounded-full font-medium hover:bg-[#5A1E2A] hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl mr-3"></i>
            Conversar com Dr. Luiz Renato Kreb
          </a>
        </div>
      </div>
    </section>
  );
}
